export function isNotNil(input) {
  return input != null
}